import { render, staticRenderFns } from "./SkeletonTixstockTrendingCategories.vue?vue&type=template&id=1531343b&scoped=true"
import script from "./SkeletonTixstockTrendingCategories.vue?vue&type=script&lang=js"
export * from "./SkeletonTixstockTrendingCategories.vue?vue&type=script&lang=js"
import style0 from "./SkeletonTixstockTrendingCategories.vue?vue&type=style&index=0&id=1531343b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1531343b",
  null
  
)

export default component.exports